import type { ReactNode } from "react";

export interface HighlightTextOptions {
  /** Class name for the highlighted (matched) span. Default: "bg-primary/20 font-semibold". */
  highlightClassName?: string;
}

/**
 * Splits text by the query (case-insensitive) and wraps each match in a <mark> element.
 * Returns a React fragment so the result can be used inline (e.g. in combobox options).
 * If query is empty, returns the original text.
 */
export function highlightMatchedText(
  text: string,
  query: string,
  options?: HighlightTextOptions,
): ReactNode {
  const q = query.trim();
  if (!q) return text;

  const lower = text.toLowerCase();
  const qLower = q.toLowerCase();
  const parts: ReactNode[] = [];
  let i = 0;
  let keyIdx = 0;

  while (i < text.length) {
    const idx = lower.indexOf(qLower, i);
    if (idx === -1) {
      parts.push(text.slice(i));
      break;
    }
    parts.push(text.slice(i, idx));
    parts.push(
      <mark
        key={keyIdx++}
        className={options?.highlightClassName ?? "bg-primary/20 font-semibold"}
      >
        {text.slice(idx, idx + q.length)}
      </mark>,
    );
    i = idx + q.length;
  }

  return <>{parts}</>;
}
